import { render, staticRenderFns } from "./OrderHistoryView.vue?vue&type=template&id=c4a06b40&"
import script from "./OrderHistoryView.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports